/**
 * Maps route paths to friendly page names for feedback collection
 */
export const getPageName = (pathname: string): string => {
  // Remove leading slash and trailing slash
  const cleanPath = pathname.replace(/^\/|\/$/g, '');
  
  // Handle root path
  if (!cleanPath) return 'Home';
  
  // Map specific routes to friendly names
  const routeMap: Record<string, string> = {
    'intro': 'Introduction',
    'platform-select': 'Platform Selection',
    'oil-gas-channel': 'Oil & Gas',
    'myspai-performance-dashboard': 'mySPAI Performance Dashboard',
    'knowledge-base-details': 'Knowledge Base Details',
    'new-knowledge-base': 'New Knowledge Base',
    'change-password': 'Change Password',
    'trey-profile': 'Trey Profile',
    'myspai-profile': 'mySPAI Profile',
    
    'explore': 'Explore',
  };
  
  // Check for exact match first
  if (routeMap[cleanPath]) {
    return routeMap[cleanPath];
  }
  
  // Handle dynamic routes with parameters
  const pathSegments = cleanPath.split('/');
  
  // Handle /myspai-profile/:username
  if (pathSegments[0] === 'myspai-profile' && pathSegments.length > 1) {
    return 'mySPAI Profile';
  }
  
  // Handle other dynamic routes if needed
  // Add more patterns as needed
  
  // Fallback: Convert kebab-case to Title Case
  return cleanPath
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
